class ArticleAnchor extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const articleAnchor = document.querySelector(".article-anchor");
    if (articleAnchor) {
      articleAnchor.style.display = "none";
    }

    const anchorSection = document.querySelector(".article-anchor p");
    const headingElement = document.querySelector(".article-text-content h4");
    const anchorList = document.querySelector(".article-anchor ul");
    const customList = document.querySelector(".custom-list");
    const textContent = document.querySelector(".article-text-content");
    const articleContent = document.querySelector(".article-content");
    const mobileContainer = document.querySelector(
      ".custom-list-container-mobile"
    );
    const desktopContainer = document.querySelector(
      ".custom-list-container-desktop"
    );

    // If anchor list is empty, hide text content and return
    if (!anchorList || anchorList.children.length === 0) {
      if (textContent) textContent.style.display = "none";
      return;
    }

    // Update heading element with anchor section text if both are present
    if (anchorSection && headingElement) {
      headingElement.textContent = anchorSection.textContent;
    }

    // If no anchor list or custom list, exit early
    if (!anchorList || !customList) return;

    // Icons array for list items
    const icons = [
      "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon1.png?v=1740556205",
      "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon2.png?v=1740556204",
      "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon3.png?v=1740556204",
      "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon4.png?v=1740556204",
    ];

    // Clear any existing content in custom list
    customList.innerHTML = "";

    // Populate custom list with items from anchor list
    anchorList.querySelectorAll("li").forEach((item, index) => {
      const li = document.createElement("li");
      li.classList.add("list-item");
      li.innerHTML = `
        <img src="${
          icons[index % icons.length]
        }" alt="Icon" width="20" height="20" class="icon">
        <span>${item.innerHTML}</span>
      `;
      customList.appendChild(li);
    });

    const handleResponsiveView = () => {
      const isMobile = window.innerWidth <= 768;
      const desktopOffset = 35;
      const offset = isMobile ? 90 : desktopOffset;

      // Handle mobile and desktop layout
      if (customList && mobileContainer && desktopContainer) {
        if (isMobile) {
          mobileContainer.appendChild(customList);
          mobileContainer.style.display = "block";
        } else {
          desktopContainer.appendChild(customList);
          mobileContainer.style.display = "none";
        }
      }

      // Mobile view (dropdown menu)
      if (isMobile) {
        customList.style.display = "none";

        // Remove any existing dropdown container
        const existingDropdown = customList.parentElement.querySelector(
          ".heading-dropdown-container"
        );
        if (existingDropdown) existingDropdown.remove();

        // Create the custom dropdown button with an icon on the right
        const dropdownContainer = document.createElement("div");
        dropdownContainer.classList.add("heading-dropdown-container");
        customList.parentElement.appendChild(dropdownContainer);

        const dropdownButton = document.createElement("button");
        dropdownButton.classList.add("heading-dropdown-button");
        dropdownButton.innerHTML = `เลือกอ่านตามหัวข้อ <i class="fas fa-angle-down dropdown-icon"></i>`;
        dropdownContainer.appendChild(dropdownButton);

        const dropdown = document.createElement("div");
        dropdown.classList.add("heading-dropdown");
        dropdown.style.display = "none";
        dropdownContainer.appendChild(dropdown);

        // Populate dropdown with items
        anchorList.querySelectorAll("li").forEach((item, index) => {
          const dropdownItem = document.createElement("div");
          dropdownItem.classList.add("dropdown-item-article");
          const anchorTag = item.querySelector("a");
          dropdownItem.setAttribute(
            "data-target",
            anchorTag ? anchorTag.getAttribute("href").substring(1) : ""
          );

          dropdownItem.innerHTML = `
            <img src="${
              icons[index % icons.length]
            }" alt="Icon" width="20" height="20" class="icon">
            <span>${item.innerText}</span>
          `;
          dropdown.appendChild(dropdownItem);
        });

        // Handle dropdown button click (toggle visibility of dropdown items)
        dropdownButton.addEventListener("click", () => {
          const isDropdownVisible = dropdown.style.display === "block";
          dropdown.style.display = isDropdownVisible ? "none" : "block";
          dropdownButton.classList.toggle("open", !isDropdownVisible);
        });

        // Handle dropdown item click (smooth scroll to section)
        dropdown.addEventListener("click", (e) => {
          const targetId = e.target
            .closest(".dropdown-item-article")
            ?.getAttribute("data-target");
          if (targetId) {
            const targetSection = document.getElementById(targetId);
            if (targetSection) {
              window.scrollTo({
                top: targetSection.offsetTop - offset,
                behavior: "smooth",
              });
              dropdown.style.display = "none";
            }
          }
        });

        // Detect and highlight current heading in the dropdown
        // const headings = document.querySelectorAll(
        //   ".article-content h2, .article-content h2 *"
        // );

        // const highlightCurrentHeading = () => {
        //   let currentHeading;
        //   headings.forEach((heading) => {
        //     const rect = heading.getBoundingClientRect();
        //     const isInViewport =
        //       rect.top <= window.innerHeight && rect.top + rect.height >= 0;
        //     if (isInViewport) {
        //       currentHeading = heading;
        //     }

        //     if (currentHeading?.id) {
        //       const selectedOption = dropdown.querySelector(
        //         `[data-target="${currentHeading.id}"]`
        //       );
        //       if (selectedOption) {
        //         dropdownButton.textContent = selectedOption.innerText;
        //         const icon = document.createElement("i");
        //         icon.className = "fas fa-angle-down dropdown-icon";
        //         dropdownButton.appendChild(icon);
        //       }
        //     }
        //   });
        // };

        // window.addEventListener("scroll", highlightCurrentHeading);
        // highlightCurrentHeading(); // Initial call to highlight the heading
      } else {
        // Desktop view setup (list view)
        customList.style.display = "block";
        const dropdownContainer = customList.parentElement.querySelector(
          ".heading-dropdown-container"
        );
        if (dropdownContainer) dropdownContainer.remove();

        const contentSection = document.querySelector(".content-section");

        if (customList.children.length > 0) {
          articleContent.style.flex = "0 0 80%";
          articleContent.style.width = "80%";

          contentSection.style.display = "flex";
        } else {
          articleContent.style.flex = "1 1 100%";
          articleContent.style.width = "100%";
        }

        // Handle click on desktop anchor links
        document
          .querySelectorAll(".custom-list-container-desktop .list-item a")
          .forEach((anchor) => {
            anchor.addEventListener("click", (e) => {
              e.preventDefault();
              const targetId = e.target.getAttribute("href").substring(1);
              const targetSection = document.getElementById(targetId);
              if (targetSection) {
                window.scrollTo({
                  top: targetSection.offsetTop - desktopOffset,
                  behavior: "smooth",
                });
              }
            });
          });
      }
    };

    // Initial call to handle responsive view on page load
    handleResponsiveView();

    // Re-check on resize
    window.addEventListener("resize", handleResponsiveView);
  }
}

customElements.define("article-anchor", ArticleAnchor);
